<template>
  <div id="conseils-cv">

    <VtoolBarFreeAccess></VtoolBarFreeAccess>
    <SideBarLanding></SideBarLanding>

    <v-content>
      <v-container>

        <AdvicesCv></AdvicesCv>

      </v-container>
    </v-content>

  </div>
</template>

<script>

 import VtoolBarFreeAccess from '../components/VtoolBarFreeAccess';
 import SideBarLanding from '../components/SideBarLanding';
 import AdvicesCv from '../components/AdvicesCv';

 export default {
   components: {
     VtoolBarFreeAccess,
     SideBarLanding,
     AdvicesCv,
   }
 }
</script>
